import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { humanizePlan } from 'features/billing/helpers'
import { subscriptionPlanSelector, isDowngradeScheduledSelector } from 'features/billing/selectors'

import { Paragraph } from './styles'

// i18n-tasks-use t('publisher.billing.change_plan.paypal.will_be_charged_html')
// i18n-tasks-use t('publisher.billing.change_plan.paypal.an_estimated_prorated_charge_html')
// i18n-tasks-use t('publisher.billing.change_plan.credit_card.will_be_charged_html')
// i18n-tasks-use t('publisher.billing.change_plan.credit_card.an_estimated_prorated_charge_html')
const WithoutScheduledDowngrade = ({ invoice }) => {
  const localizationKey = invoice.ignore_charge
    ? 'will_be_charged_html'
    : 'an_estimated_prorated_charge_html'

  return (
    <div>
      <Paragraph>
        {HtmlParser(
          I18n.t('publisher.billing.change_plan.invoice_message.quantity_increase.extra_amount_html', {
            count: invoice.extra_quantity,
            amount: invoice.extra_amount_due,
            date: invoice.next_payment_date,
            plan: invoice.new_plan_id && humanizePlan(invoice.new_plan_id)
          })
        )}
        &nbsp;
        {I18n.t('publisher.billing.change_plan.invoice_message.quantity_increase.unused_seats_warning', {
          count: invoice.extra_quantity
        })}
      </Paragraph>
      <Paragraph>
        {HtmlParser(
          I18n.t(`publisher.billing.change_plan.${invoice.kind}.${localizationKey}`, {
            amount: invoice.today_amount_due,
            card_brand: invoice.card_brand,
            card_last4: invoice.card_last4
          })
        )}
      </Paragraph>
    </div>
  )
}

// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.quantity_increase.paypal.will_be_charged_html')
// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.quantity_increase.paypal.charge_html')
// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.quantity_increase.credit_card.will_be_charged_html')
// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.quantity_increase.credit_card.charge_html')
const WithScheduledDowngrade = ({ invoice }) => {
  const currentPlanId = useSelector(subscriptionPlanSelector)

  return (
    <div>
      <Paragraph>
        {HtmlParser(
          I18n.t('publisher.billing.change_plan.invoice_message.quantity_increase.extra_amount_html', {
            count: invoice.extra_quantity,
            amount: invoice.extra_amount_due,
            date: invoice.next_payment_date,
            plan: invoice.new_plan_id && humanizePlan(invoice.new_plan_id)
          })
        )}
        &nbsp;
        {I18n.t('publisher.billing.change_plan.invoice_message.quantity_increase.unused_seats_warning', {
          count: invoice.extra_quantity
        })}
      </Paragraph>
      <Paragraph>
        {HtmlParser(
          I18n.t(invoice.ignore_charge ? 'will_be_charged_html' : 'charge_html', {
            scope: `publisher.billing.change_plan.invoice_message.quantity_increase.${invoice.kind}`,
            amount: invoice.today_amount_due,
            date: invoice.next_payment_date,
            plan: currentPlanId && humanizePlan(currentPlanId),
            card_brand: invoice.card_brand,
            card_last4: invoice.card_last4
          })
        )}
      </Paragraph>
    </div>
  )
}

export const IncreaseQuantityInvoiceMessage = ({ invoice }) => {
  const isDowngradeScheduled = useSelector(isDowngradeScheduledSelector)

  return isDowngradeScheduled
    ? <WithScheduledDowngrade invoice={invoice} />
    : <WithoutScheduledDowngrade invoice={invoice} />
}
